module.exports = __webpack_public_path__ + "static/media/banner_small.b615d020.jpg";